import { render, staticRenderFns } from "./PHeader.vue?vue&type=template&id=10df83c5&scoped=true&"
import script from "./PHeader.vue?vue&type=script&lang=js&"
export * from "./PHeader.vue?vue&type=script&lang=js&"
import style0 from "./PHeader.vue?vue&type=style&index=0&id=10df83c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df83c5",
  null
  
)

export default component.exports